import {useRef, useState} from 'react'
import {Upload, X} from 'lucide-react'
import {LoaderNew} from '../../components/LoaderNew'
import {envVariables} from '../../utils/envVariables/envVariables'

export const CargaMasiva = ({setCargaMasiva, idPromocion, promotion}) => {
	const [statusButton, setStatusButton] = useState('Cargar Archivo')
	const [loader, setLoader] = useState(false)
	const [erroresValidacion, setErroresValidacion] = useState(null)
	const fileInput = useRef(null)
	const confirmarEnvio = async () => {
		const myHeaders = new Headers()
		myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('token'))
		try {
			const response = await fetch(
				envVariables.baseUrl + '/promotion/bulk/create',
				{
					method: 'POST',
					headers: myHeaders,
				}
			)
			if (!response.ok) {
				const data = await response.json().catch(() => ({}))
				throw new Error(
					data?.message || 'No se pudo confirmar la carga masiva.'
				)
			}
			window.location.reload()
		} catch (error) {
			console.error('Error:', error)
			alert('Error ' + error.message)
			setStatusButton('Confirmar Envío')
			setLoader(false)
		}
	}

	const enviarArchivo = async () => {
		const file = fileInput.current.files[0]
		if (!file) {
			setErroresValidacion('Debes seleccionar un archivo Excel.')
			setStatusButton('Cargar Archivo')
			setLoader(false)
			return
		}
		const myHeaders = new Headers()
		myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('token'))
		const formData = new FormData()
		formData.append('file', file)
		formData.append(
			'nombre_cadena',
			String(promotion.data_promocion.nombre_cadena).toUpperCase()
		)
		formData.append('id_promocion', idPromocion)
		try {
			const response = await fetch(
				envVariables.baseUrl + '/promotion/bulk/validate',
				{
					method: 'POST',
					headers: myHeaders,
					body: formData,
				}
			)
			const data = await response.json()
			if (!response.ok) {
				throw new Error(data?.message || 'Error en la solicitud')
			}

			if (data.error_messages?.length > 0) {
				const errores = data.error_messages
					.map(
						(error) =>
							`- ${error.codigo_producto || 'Sin código'} | ${
								error.tipo_promocion || 'Tipo inválido'
							}: ${error.mensajes_error || `${error.total_errores} error(es)`}`
					)
					.join('\n')
				setErroresValidacion(errores)
				setStatusButton('Cargar Archivo')
			} else {
				setErroresValidacion(
					'Todas las filas están correctas, ¿Desea confirmar el envío?'
				)
				setStatusButton('Confirmar Envío')
			}
		} catch (error) {
			console.error('Error:', error)
			alert('Error ' + error.message)
			setErroresValidacion(
				error.message || 'Error en la carga masiva, intente más tarde.'
			)
			setStatusButton('Cargar Archivo')
		} finally {
			setLoader(false)
		}
	}

	const descargarTemplate = async () => {
		try {
			const response = await fetch(
				`${envVariables.baseUrl}/promotion/bulk/template/mixed`,
				{
					method: 'GET',
					headers: {
						Authorization: `Bearer ${localStorage.getItem('token')}`,
					},
				}
			)

			if (!response.ok) {
				throw new Error('No se pudo descargar el template.')
			}

			const blob = await response.blob()
			const url = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url
			link.download = 'template_carga_masiva_mixta.xlsx'
			document.body.appendChild(link)
			link.click()
			link.remove()
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error('Error al descargar template:', error)
			alert(error?.message || 'No se pudo descargar el template.')
		}
	}

	return (
		<>
			<span
				className='black_bg popup'
				onClick={(e) => {
					setCargaMasiva(null)
				}}
			></span>
			<div className='LogoutPopupNew InicioPop'>
				<span
					style={{
						width: 44,
						height: 44,
						minWidth: 44,
						minHeight: 44,
						flexShrink: 0,
						borderRadius: '50%',
						background: '#F0F4FC',
						display: 'inline-flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Upload size={22} color='#3676F5' />
				</span>

				<h1>Carga Masiva SELL-IN / SELL-OUT</h1>
				<p id={'erroresValidacion'}>
					Usa el formato único e indica el tipo de promoción en cada fila:
					<button
						type='button'
						className='bulk-template-link'
						onClick={descargarTemplate}
					>
						template
					</button>
					<input
						type='file'
						id='file'
						name='file'
						accept='.xlsx'
						ref={fileInput}
					/>
					{loader && <LoaderNew notdo={true} />}
					{erroresValidacion && (
						<span style={{whiteSpace: 'pre-line'}}>{erroresValidacion}</span>
					)}
				</p>

				<div className='button_wrapper'>
					<button
						onClick={(e) => {
							if (statusButton !== 'Confirmar Envío') {
								enviarArchivo()
								// setCargaMasiva(null)
								setStatusButton('Cargando...')
								setLoader(true)
							} else {
								confirmarEnvio()
								setStatusButton('Enviando...')
								setLoader(true)
							}
						}}
					>
						{statusButton}
					</button>
				</div>

				<X
					onClick={(e) => setCargaMasiva(false)}
					size={10}
					color='#ADADAD'
					style={{cursor: 'pointer'}}
				/>
			</div>
		</>
	)
}
